import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color } = baseVariables;

export const StyledEventSummaryModal = styled.div`
  .accordion-container {
    border-top: ${toRem(1)} solid ${color.neutral30};

    .accordion-header {
      display: flex;
      justify-content: space-between;
      margin-right: ${toRem(16)};

      .edit-cta {
        text-decoration: underline;
        font-weight: normal;
        font-size: ${toRem(12)};
      }
    }
  }
`;
